export const environment = {
  production: false,

  apiUrl: 'https://sod-svc.ssmopen.it',
  catalogoApiUrl: 'https://sod-svc.ssmopen.it',
  prenotazioneApiUrl: 'https://sod-svc.ssmopen.it',
  indirizzoApiUrl: 'https://sod-svc.ssmopen.it',
  mobileAppBeApiUrl: 'https://sod-svc.ssmopen.it',
  anaWikiApiUrl: 'https://sod-svc.ssmopen.it',

  xSodToken: ""
};
